// extracted by mini-css-extract-plugin
export default {"section":"gallery_section__lj4ZS","container":"gallery_container__Z4+VN"};